"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_SRCSET_VALUE = exports.PathEnum = void 0;
var PathEnum;
(function (PathEnum) {
    PathEnum["DefaultImage"] = "/static/icons/no-image.svg";
    PathEnum["DefaultVideoImage"] = "/static/icons/no-video.svg";
})(PathEnum || (exports.PathEnum = PathEnum = {}));
// needed for srcset attribute to create valid 'source' element.
exports.DEFAULT_SRCSET_VALUE = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAACCAQAAAA3fa6RAAAAEElEQVR42mP8/58BCBghFAAj/wP/DcJIqAAAAABJRU5ErkJggg==';
